import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  AddressSuggestion,
  AddressSuggestionsEntity,
  AddressSuggestionsError,
} from "./addressSuggestionsInterfaces";

const initialState: AddressSuggestionsEntity = {
  current: [],
  error: null,
  isLoading: false,
};

const addressSuggestionsSlice = createSlice({
  name: "addressSuggestions",
  initialState,
  reducers: {
    resetAddressSuggestions: (state) => {
      state.current = [];
      state.isLoading = false;
      state.error = null;
    },
    fetchAddressSuggestionsStart: (
      state,
      _payload: PayloadAction<{
        query: string;
        limit?: number;
      }>,
    ) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchAddressSuggestionsSuccess: (
      state,
      payload: PayloadAction<AddressSuggestion[]>,
    ) => {
      state.current = payload.payload;
      state.isLoading = false;
      state.error = null;
    },
    operationFailed: (
      state,
      payload: PayloadAction<AddressSuggestionsError>,
    ) => {
      state.current = [];
      state.error = payload.payload;
      state.isLoading = false;
    },
  },
});

export const {
  fetchAddressSuggestionsStart,
  fetchAddressSuggestionsSuccess,
  operationFailed,
  resetAddressSuggestions,
} = addressSuggestionsSlice.actions;
export const addressSuggestions = addressSuggestionsSlice.reducer;
